<header class="w-full h-18 bg-white border-b border-slate-200 sticky top-0 z-50">
    <div class="max-w-[1600px] mx-auto px-6 h-full flex items-center justify-between">
        <div class="flex items-center gap-24">
            <div class="flex items-center gap-2 relative">
                <div
                    class="absolute -inset-x-4 -inset-y-2 bg-primary/5 blur-xl rounded-full opacity-50 pointer-events-none">
                </div>
                <span
                    class="text-[16px] font-black text-[#003359] tracking-tight uppercase relative z-10">Student Support Services</span>
            </div>

            @if (isAuthenticated && isValidUser) {
                <nav class="hidden lg:flex items-center gap-3" aria-label="Main Navigation">
                    @for (link of mainLinks; track link.path) {
                        @if(link.show) {
                    <a [routerLink]="link.path" routerLinkActive="bg-gradient-primary !text-white font-bold shadow-md hover:!text-white"
                        [routerLinkActiveOptions]="{exact: link.exact}" #rla="routerLinkActive"
                        [attr.aria-current]="rla.isActive ? 'page' : null"
                        class="header-padding px-5 py-2 rounded-xl text-[13px] font-medium text-slate-600 hover:text-primary hover:scale-105 transition-all focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary outline-none">
                        {{ link.label }}
                    </a>
                        }
                    }
                </nav>
            }
        </div>

        <div class="flex items-center gap-6">
            @if (isAuthenticated && isValidUser) {
                <div class="flex items-center gap-4">
                    <div class="flex items-center gap-2.5 px-4 py-1 rounded-xl bg-white border border-slate-200 shadow-sm hover:shadow-md transition-shadow">
                        <div class="w-8 h-8 rounded-full bg-gradient-primary flex items-center justify-center flex-shrink-0">
                            <span class="text-white font-bold text-sm">{{userName.charAt(0).toUpperCase()}}</span>
                        </div>
                        <span class="text-slate-700 font-semibold text-[13px]">{{userName}}</span>
                    </div>
                    <button (click)="logout()" aria-label="Logout"
                        class="flex items-center gap-2 px-6 py-2.5 bg-gradient-primary text-white text-[13px] font-bold rounded-xl hover:scale-105 transition-all shadow-md active:scale-95 group">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                            class="transition-transform group-hover:translate-x-0.5" aria-hidden="true">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                            <polyline points="16 17 21 12 16 7"></polyline>
                            <line x1="21" y1="12" x2="9" y2="12"></line>
                        </svg>
                        <span>Logout</span>
                    </button>
                </div>
            }
            @else {
                @if(isValidationPage !== '/user/validate') {
                <div class="flex items-center">
                    <button (click)="login()" aria-label="Login"
                        class="flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-primary to-blue-600 text-white text-[13px] font-bold rounded-xl hover:scale-105 hover:shadow-lg hover:from-primary hover:to-blue-700 transition-all shadow-md active:scale-95 group border-none cursor-pointer">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                            class="transition-transform group-hover:translate-x-0.5" aria-hidden="true">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                            <polyline points="16 17 21 12 16 7"></polyline>
                            <line x1="21" y1="12" x2="9" y2="12"></line>
                        </svg>
                        <span>Login</span>
                    </button>
                </div>
                } 
            }
      @if (isAuthenticated && isValidUser) {
            <button (click)="isMobileMenuOpen = !isMobileMenuOpen"
                class="lg:hidden w-10 h-10 flex items-center justify-center text-primary border border-slate-200 rounded-xl">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    @if (!isMobileMenuOpen) {
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7">
                    </path>
                    } @else {
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                    </path>
                    }
                </svg>
            </button>
        }
        </div>
        @if (isAuthenticated && isValidUser && isMobileMenuOpen) {
        <div
            class="lg:hidden absolute top-full left-0 w-full bg-white border-b border-slate-200 shadow-xl p-4 animate-in slide-in-from-top-2">
            <nav class="flex flex-col gap-2">
                @for (link of mainLinks; track link.path) {
                <a [routerLink]="link.path" (click)="isMobileMenuOpen = false"
                    routerLinkActive="bg-gradient-primary text-white font-bold shadow-md"
                    class="text-text-muted hover:text-primary hover:scale-105 px-4 py-3 rounded-xl transition-all text-base">
                    {{ link.label }}
                </a>
                }
            </nav>
        </div>
        }
    </div>
</header>